import { jsx as t } from "react/jsx-runtime";
import f from "clsx";
import { AspectRatio as h } from "../AspectRatio/AspectRatio.js";
const v = (c) => {
  const {
    src: s,
    alt: e = "",
    className: a,
    width: r,
    height: i,
    aspectRatio: o,
    imgClassName: m,
    decorative: l = !1
  } = c, n = typeof s == "object" ? s.src : s;
  return /* @__PURE__ */ t(h, { width: r, height: i, aspectRatio: o, className: a, children: ({ style: d, containerClassName: p, childClassName: g }) => /* @__PURE__ */ t("div", { style: d, className: p, children: /* @__PURE__ */ t(
    "img",
    {
      alt: l ? "" : e.trim() || "",
      src: n,
      decoding: "async",
      className: f(g, m)
    }
  ) }) });
};
export {
  v as Img
};
